<template>
    <div class="login-page">
        <div class="login-container">
            <div class="login-header">
                <router-link to="/blogs" class="logo-link">
                    <img class="logo" src="../assets/logo.png" alt="Logo">
                    <h1 class="site-title">My Blog</h1>
                </router-link>
                <p class="site-desc">记录思考，分享生活</p>
            </div>

            <div class="login-card">
                <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" class="login-form" @submit.native.prevent>
                    <el-form-item prop="username">
                        <el-input
                            type="text"
                            maxlength="12"
                            v-model="ruleForm.username"
                            prefix-icon="el-icon-user"
                            placeholder="请输入用户名"
                        ></el-input>
                    </el-form-item>

                    <el-form-item prop="password">
                        <el-input
                            type="password"
                            v-model="ruleForm.password"
                            prefix-icon="el-icon-lock"
                            placeholder="请输入密码"
                            @keyup.enter.native="submitForm('ruleForm')"
                        ></el-input>
                    </el-form-item>

                    <el-form-item>
                        <el-button
                            type="primary"
                            class="login-btn"
                            @click="submitForm('ruleForm')"
                            :loading="loading"
                        >登录</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>

        <div class="login-footer">
            Powered by Vue.js & Spring Boot
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Login',
        data() {
            var validatePass = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请输入密码'));
                } else {
                    callback();
                }
            };
            return {
                loading: false,
                ruleForm: {
                    password: '',
                    username: ''
                },
                rules: {
                    password: [
                        {validator: validatePass, trigger: 'blur'}
                    ],
                    username: [
                        {required: true, message: '请输入用户名', trigger: 'blur'},
                        {min: 3, max: 12, message: '长度在 3 到 12 个字符', trigger: 'blur'}
                    ]
                }
            };
        },
        methods: {
            submitForm(formName) {
                const _this = this
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        _this.loading = true
                        this.$axios.post('/login', this.ruleForm).then((res) => {
                            const token = res.headers['authorization'] || res.data.data?.token || ''
                            const data = res.data.data
                            // 后端返回的数据结构可能是 { user: {...} } 或直接是用户对象
                            const userInfo = data.user || data
                            console.log('登录成功，token:', token)
                            console.log('登录成功，用户信息:', userInfo)
                            _this.$store.commit('SET_TOKEN', token)
                            _this.$store.commit('SET_USERINFO', userInfo)
                            _this.loading = false
                            _this.$router.push("/blogs")
                        }).catch((err) => {
                            console.log('登录失败:', err)
                            _this.loading = false
                        })
                    }
                });
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
            }
        }
    }
</script>

<style scoped>
    .login-page {
        min-height: 100vh;
        display: flex;
        flex-direction: column;
        background: #f5f5fb;
    }

    .login-container {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 40px 20px;
    }

    .login-header {
        text-align: center;
        margin-bottom: 32px;
    }

    .logo-link {
        display: inline-flex;
        flex-direction: column;
        align-items: center;
        text-decoration: none;
    }

    .logo {
        width: 64px;
        height: 64px;
        margin-bottom: 12px;
    }

    .site-title {
        font-size: 28px;
        font-weight: 700;
        color: #58a8e0;
        margin: 0;
        letter-spacing: 1px;
    }

    .site-desc {
        color: #58a8e0;
        font-size: 14px;
        margin: 8px 0 0;
    }

    .login-card {
        background: #fff;
        border-radius: 12px;
        padding: 40px 36px;
        width: 100%;
        max-width: 400px;
        box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
    }

    .login-form >>> .el-input__inner {
        height: 44px;
        border-radius: 8px;
        border: 1px solid #e4e7ed;
        font-size: 14px;
    }

    .login-form >>> .el-input__inner:focus {
        border-color: #58a8e0;
        box-shadow: 0 0 0 2px rgba(88, 168, 224, 0.15);
    }

    .login-form >>> .el-form-item {
        margin-bottom: 22px;
    }

    .login-btn {
        width: 100%;
        height: 44px;
        border-radius: 8px;
        font-size: 16px;
        font-weight: 500;
        background: #58a8e0;
        border: none;
    }

    .login-btn:hover {
        background: #4a9ad0;
    }

    .login-footer {
        text-align: center;
        color: rgba(255, 255, 255, 0.5);
        font-size: 12px;
        padding: 20px;
    }
</style>
